import { Link } from "react-router-dom";

interface SplitSectionProps {
  title: string;
  description: string;
  children?: React.ReactNode;
  cta?: { text: string; href: string };
  image?: string;
  imageAlt?: string;
  reverse?: boolean;
}

const SplitSection = ({
  title,
  description,
  children,
  cta,
  image,
  imageAlt = "",
  reverse = false,
}: SplitSectionProps) => {
  const textBlock = (
    <div className="space-y-5">
      <h2 className="font-headline text-3xl sm:text-4xl md:text-[2.75rem] text-foreground leading-tight">
        {title}
      </h2>
      <p className="text-muted-foreground text-base md:text-lg leading-relaxed">{description}</p>
      {children}
      {cta && (
        <div className="pt-2">
          <Link
            to={cta.href}
            className="inline-block font-body text-sm uppercase tracking-widest text-accent hover:text-accent/80 transition-colors"
          >
            {cta.text} →
          </Link>
        </div>
      )}
    </div>
  );

  const visualBlock = image ? (
    <div className="aspect-[4/3] overflow-hidden">
      <img src={image} alt={imageAlt} className="w-full h-full object-cover" loading="lazy" />
    </div>
  ) : (
    <div className="bg-secondary on-dark aspect-[4/3] flex items-center justify-center">
      <span className="font-body text-xs uppercase tracking-widest text-muted-foreground">
        Image Placeholder
      </span>
    </div>
  );

  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center ${reverse ? "md:[&>*:first-child]:order-2" : ""}`}>
      {textBlock}
      {visualBlock}
    </div>
  );
};

export default SplitSection;
